// extracted by mini-css-extract-plugin
export default {"nfLoader":"styles_nfLoader__tfR5L","nfLoader-spin":"styles_nfLoader-spin__1vhcL"};